
<script setup>

  import { ref } from 'vue';

  import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';

  import { XCircleIcon } from '@heroicons/vue/24/outline';

  const props = defineProps( { date: String, title: String, path: String, alt: String, caption: String } );

  const isOpen = ref( false );

  function open() {
    
    isOpen.value = true;

  }

  function close() {
    
    isOpen.value = false;

  }

</script>

<template>

  <slot :open="open" :close="close" />

  <TransitionRoot appear :show="isOpen" as="template">

    <Dialog as="div" @close="close" class="fixed inset-0 overflow-hidden z-20 drop-shadow-[0_0_15px_rgba(0,0,0,0.5)]">

      <div class="absolute inset-y-0 right-0 overflow-hidden">

        <TransitionChild

          as="template"

          enter="transition transform duration-300 ease-out"

          enter-from="translate-x-full"

          enter-to="translate-x-0"

          leave="transition transform duration-200 ease-in"

          leave-from="translate-x-0"

          leave-to="translate-x-full">

          <DialogPanel class="flex flex-col h-view p-8 mt-header text-white bg-black/90">
            
            <div class="flex items-center justify-between gap-5">

              <DialogTitle as="h3">

                <div class="text-lg font-bold">{{ date }}</div>

                <div class="text-2xl md:text-4xl font-heading uppercase">{{ title }}</div>

              </DialogTitle>

              <button type="button" @click="close" class="group flex items-center gap-2">

                <div class="text-sm group-focus-visible:underline group-hover:underline">Close</div>

                <XCircleIcon class="w-8" />
              
              </button>

            </div>

            <figure class="flex flex-col min-h-0 grow mt-5">

              <div class="min-h-0 grow">

                <img class="w-full h-full object-contain" :src="path" :alt="alt" draggable="false" />

              </div>

              <figcaption class="mt-5" v-html="caption" v-if="caption" />

            </figure>

          </DialogPanel>

        </TransitionChild>

      </div>

    </Dialog>

  </TransitionRoot>

</template>
